import { KeyboardBackspace } from "@mui/icons-material";
import { Container, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useTranslation } from "react-i18next";
import ActiveSubscriptions from "./components/ActiveSubscriptions";
import InactiveSubscriptions from "./components/InactiveSubscriptions";

const Subscriptions = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const page = "subscriptions";

  return (
    <Container maxWidth="xl" disableGutters>
      <Stack gap={isMobile ? 1 : 2}>
        <Stack direction="row" alignItems="center">
          {isMobile ? (
            <IconButton sx={{ color: "#00B6B8" }} onClick={() => navigate(-1)}>
              <KeyboardBackspace fontSize="large" />
            </IconButton>
          ) : null}
          <Stack gap={2}>
            <Typography variant="h5" fontWeight={700}>
              {t(`${page}.header`, "Subscriptions")}
            </Typography>
          </Stack>
        </Stack>
        <ActiveSubscriptions />
        <InactiveSubscriptions />
      </Stack>
    </Container>
  );
};

export default Subscriptions;
